<script setup>
import { vMaska } from 'maska/vue';
import { ref, inject } from 'vue';
import { __, inputValidEmail, handleNameField, handleNameFieldPaste, isNumber, handleNumberFieldPaste } from '@/utils';
import { Field, ErrorMessage, useField } from 'vee-validate';
import FieldID from '@components/fieldID/fieldID.vue';

const {handleChange} = useField('subscriberPhone')

const { handleChange: handleFirstNameChange } = useField('subscriberFirstName');
const { handleChange: handleLastNameChange } = useField('subscriberLastName');

const handleSelectedNumber = (number) => handleChange(number);

const {
    subscriberDisableExistingFields
} = inject('step2');
</script> 
<template>
	<div class="fields">
		<div class="fields__head">
			<h6>
				{{ __('Details of the subscriber') }}
			</h6>
		</div><!-- /.fields__head -->

		<div class="fields__body fields__body--align-end">
			<div class="field field--mobile-half field--w160">
				<ErrorMessage name="subscriberFirstName" as="span" class="field__error" />

				<label for="field-fname">
					<strong>{{ __('First name') }} *</strong>
				</label><!-- /.form__label -->

				<Field
					type="text"
					name="subscriberFirstName"
					id="field-fname"
					:disabled = "subscriberDisableExistingFields"
					@keypress="handleNameField"
					@paste="handleNameFieldPaste"
					@blur="handleFirstNameChange($event.target.value.trim())"
				/>
			</div><!-- /.field -->

			<div class="field field--mobile-half field--w160">
				<ErrorMessage name="subscriberLastName" as="span" class="field__error" />

				<label for="field-lname">
					<strong>{{ __('Last Name') }} *</strong>
				</label><!-- /.form__label -->

				<Field
					type="text"
					name="subscriberLastName"
					id="field-lname"
					:disabled = "subscriberDisableExistingFields"
					@keypress="handleNameField"
					@paste="handleNameFieldPaste"
					@blur="handleLastNameChange($event.target.value.trim())"
				/>
			</div><!-- /.field -->

			<FieldID
				name="subscriber"
				@selectedNumber="handleSelectedNumber"
			/>

			<div class="field field--w160">
				<ErrorMessage name="subscriberPhone" as="span" class="field__error" />

				<label for="field-phone">
					<strong>{{ __('Contact Phone Number') }} *</strong>
				</label><!-- /.form__label -->

				<Field
					type="text"
					name="subscriberPhone"
					id="field-phone"
					v-maska
					data-maska="###-##########"
					@keypress="isNumber($event)" maxlength="11"
					@paste="handleNumberFieldPaste"
					:disabled = "subscriberDisableExistingFields"
				/>
			</div><!-- /.field -->

			<div class="field">
				<ErrorMessage name="subscriberEmail" as="span" class="field__error" />

				<label for="field-email">
					<strong>{{ __('Email') }} *</strong>
				</label><!-- /.form__label -->

				<Field
					type="email"
					name="subscriberEmail"
					id="field-email"
					:disabled = "subscriberDisableExistingFields"
					@keypress="inputValidEmail"
				/>
			</div><!-- /.field -->
		</div><!-- /.fields__body -->
	</div><!-- /.fields -->

</template>
